import FbButton, { IFbButtonProps } from 'components/FbUI/FbButton'
import { cn } from 'components/UI/cn'
import React from 'react'
import { IconType } from 'react-icons'

export interface ITableButtonProps extends IFbButtonProps {
  icon?: ((props: any) => React.JSX.Element) | IconType
  text?: string
  activeValue?: string | null
  iconSize?: number

  postpendIcon?: ((props: any) => React.JSX.Element) | IconType
  onPostpendIconClick?: () => void
}

const TableButton = React.forwardRef((props: ITableButtonProps, ref: any) => {
  const {
    icon,
    text,
    activeValue,
    iconSize = 24,
    postpendIcon,
    onPostpendIconClick,
    ...rest
  } = props

  // Helper function to render icon properly
  const renderIcon = (IconComponent: typeof icon, size: number) => {
    if (typeof IconComponent === 'function') {
      // Try calling it as a function first (for function components)
      try {
        const result = IconComponent({ size })
        // If it returns a valid React element, use it
        if (React.isValidElement(result)) {
          return result
        }
      } catch (e) {
        // If calling as function fails, treat as component
      }
      // Treat as React component (IconType)
      return <IconComponent size={size} />
    }
    return null
  }

  return (
    <div className="flex xl:min-w-[140px] min-h-[38px]">
      <FbButton
        ref={ref}
        variant="secondary"
        className={cn(
          {
            active: activeValue !== null,
            'rounded-r-none': !!postpendIcon,
          },
          'bg-white xl:min-w-[120px] gap-2 justify-start text-nowrap flex-1'
        )}
        {...rest}
      >
        {renderIcon(icon, iconSize)}
        <span className={'hidden xl:inline'}>
          {text}
          {activeValue && (
            <span>
              {' '}
              (
              <span>
                <strong>{activeValue}</strong>
              </span>
              )
            </span>
          )}
        </span>
      </FbButton>
      {!!postpendIcon && (
        <FbButton
          variant={'primary'}
          className="rounded-l-none rounded-r px-2 -ml-1"
          onClick={onPostpendIconClick}
        >
          {renderIcon(postpendIcon, iconSize)}
        </FbButton>
      )}
    </div>
  )
})
TableButton.displayName = 'TableButton'
export default TableButton
